import Curd from "./Curd"
export default class Log extends Curd {
    BASE_PATH = "/log"
}